import * as React from 'react';
import { cn } from '@/lib/utils';

const QuickActions = React.forwardRef(({ className, ...props }, ref) => (
  <section
    ref={ref}
    className={cn(
      'c-quick-actions',
      // styles
      'flex flex-wrap gap-3',
      className
    )}
    {...props}
  />
));
QuickActions.displayName = 'QuickActions';

export { QuickActions };
